<template lang="pug">
    #tag-list
        model-data-table(
            loading-text="Cargando tags..."
            no-data-text="Sin tags."
            no-search
            ref="table"
            remind-key='wh-tag-list'
            v-bind="tableProps"
            @detail="submitShow"
            @remove="deleteItem"
            :no-detail="!$can('VIEW_DETAIL_PRODUCT_TAG')"
            :no-remove="!$can('DELETE_PRODUCT_TAG')"
            )
        v-dialog(v-model="dialogCreateTag" width='900')
            v-card
                model-form(
                    title="Crear tag"
                    ref="form"
                    reset-text="limpiar"
                    submit-text="crear etiqueta"
                    :fields="fields"
                    v-model="formData"
                    @reset="resetFormCreate"
                    @submit="handleSubmitCreate"
                    )
        v-dialog(v-model="dialogDetailTag" width='900')
            v-card
                model-form(
                    title="Detalle tag"
                    ref="form"
                    reset-text="restablecer"
                    submit-text="editar etiqueta"
                    :switchEdit="$can('EDIT_PRODUCT_FAMILY')"
                    :editable="isEditable"
                    :fields="fields"
                    v-model="formDataDetail"
                    @reset="resetFormDetail"
                    @submit="handleSubmitUpdate"
                    )
</template>

<script>
//-
import {
    ModelDataTable,
    ModelForm,
} from '@/components/reusable_components/next'
import { mapActions, mapState } from 'vuex'
//
import { DELETE_TAG } from '@/components/SnackbarModal/SnackbarActions'
import TagServices from '@/services/api/tag/TagServices'
//-
import MdlTag from '../../models/Warehouse/WhTag'
import HeadersTag from './headers'
import FiltersTag from './filters'
import FieldsCreate from './FieldsCreate'
//
export default {
    name: 'tag-list',
    props: {},
    data: function() {
        return {
            headers: HeadersTag,
            filters: FiltersTag,
            selected: [],
            selectedItemId: null,
            dialogCreateTag: false,
            dialogDetailTag: false,
            fields: FieldsCreate,
            formData: {},
            formDataDetail: {},
            isEditable: false,
        }
    },
    computed: {
        ...mapState('SnackbarModalModule', {
            responseConfirm: 'responseConfirm',
        }),
        tableProps() {
            return {
                service: MdlTag,
                headers: this.headers,
                filters: this.filters,
            }
        },
    },
    methods: {
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            hideSnack: 'hideSnack',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),
        submitShow: function(event) {
            this.dialogDetailTag = true
            this.formDataDetail = event.item
        },
        deleteItem(event) {
            this.resetSnackbarState()
            this.setMessageConfirmSnack(DELETE_TAG)
            let payload = this.fillSnack(
                'warning',
                'Advertencia',
                '¿Desea eliminar tag?'
            )
            this.initSnackbar(payload)
            this.selectedItemId = event.item.id
        },
        handleSubmitCreate: function(data) {
            new MdlTag(data)
                .save()
                .then(r => this.handleResponse(r, 1))
                .catch(this.showErrorSnackbar)
        },
        handleResponse(response, opt) {
            if (response.status === 'success') {
                switch (opt) {
                    case 1:
                        this.dialogCreateTag = false
                        break
                    case 2:
                        this.dialogDetailTag = false
                        break
                }
                return this.showSuccessSnackbar(opt)
            }
            return this.showErrorSnackbar(response)
        },
        showErrorSnackbar(response) {
            this.initSnackbar(
                this.fillSnack('error', 'Error', response.error, false, 3000)
            )
        },
        showSuccessSnackbar(opt) {
            this.$refs.table.refresh()
            let message = opt === 1 ? 'creada' : 'editada'
            this.initSnackbar(
                this.fillSnack(
                    'success',
                    'Éxito',
                    `Etiqueta ${message} exitosamente.`,
                    false,
                    3000
                )
            )
        },
        resetFormCreate: function() {
            this.formData = {}
        },
        //- Details methods
        resetFormDetail: function() {
            this.formDataDetail = {}
        },
        handleSubmitUpdate: function(data) {
            new MdlTag(data)
                .save()
                .then(r => this.handleResponse(r, 2))
                .catch(this.showErrorSnackbar)
        },
    },
    watch: {
        async responseConfirm(val) {
            if (val === DELETE_TAG) {
                this.resetSnackbarState()
                let response = await TagServices.deleteTag(this.selectedItemId)
                if (response.status == 200) {
                    let payload = this.fillSnack(
                        'success',
                        'Éxito',
                        'Tag eliminado con éxito.'
                    )
                    this.initSnackbar(payload)
                    this.$refs.table.refresh()
                } else {
                    let payload = this.fillSnack(
                        'error',
                        'Error',
                        response.error
                    )
                    this.initSnackbar(payload)
                }
            }
        },
    },
    components: {
        'model-data-table': ModelDataTable,
        'model-form': ModelForm,
    },
    beforeMount: function() {
        this.setTitleTopBar('Listado de tags')
        this.$setItemsTopBar([
            {
                text: 'crear tag',
                icon: 'add',
                can: 'CREATE_PRODUCT_TAG',
                action: () => (this.dialogCreateTag = true),
            },
        ])
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can('VIEW_ALL_PRODUCT_TAG')) ctx.$router.push('/')
        })
    },
}
</script>

<style lang="scss"></style>
